import { AUTH_API_BASE } from '../../config/api';
import { createScreenStyles } from '../../theme/styles';
import React, { useState } from 'react';
import {
  View,
  SafeAreaView,
  Text,
  Image,
  StyleSheet,
  Dimensions,
  ScrollView,
  TouchableHighlight,
  TextInput,
  ImageBackground,
  ActivityIndicator,
  Keyboard
} from 'react-native';

import logo from './assets/logo.png';
import backg from './assets/backg.jpg';

const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);

const Forgot = ({ navigation }) => {

  const [email, setEmail] = useState("");
  const [erroValidador, setErroValidador] = useState("");
  const [loading, setLoading] = useState(false);

  function handleBack() {
    navigation.navigate('Login');
  }

  async function handleSubmit() {

    Keyboard.dismiss();

    if (email.trim() === '') {
      setErroValidador('preencha seu e-mail');
      return;
    }

    setErroValidador('');

    const reg =
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email.trim()) === false) {
      setErroValidador(
        'O e-mail não é válido. Por favor verifique'
      );
      return;
    }

    setLoading(true);

    try {

      const responseApi = await fetch(
        `${AUTH_API_BASE}/forgotpwd`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },

          body: JSON.stringify({
            email: email.trim()
          }),
        }
      );

      const data = await responseApi.json();

      console.log(
        'FORGOT PASSWORD STATUS:',
        responseApi.status
      );

      console.log(
        'FORGOT PASSWORD RESPONSE:',
        data
      );

      if (data?.error) {
        setErroValidador(data.error);
        return;
      }

      if (!responseApi.ok) {
        setErroValidador(
          'Não foi possível solicitar uma nova senha.'
        );
        return;
      }

      alert(
        'E-mail enviado com as instruções para obter nova senha'
      );

      navigation.navigate('Login');

    } catch (error) {

      console.error(
        'ERRO FORGOT PASSWORD:',
        error
      );

      setErroValidador(
        'Erro ao solicitar nova senha. Tente novamente.'
      );

    } finally {

      setLoading(false);
    }
  }

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView keyboardShouldPersistTaps="handled" contentContainerStyle={styles.page}>
        <Image source={logo} resizeMode="contain" style={styles.logo} />
        <Text style={styles.eyebrow}>PORTAL OPERACIONAL</Text>
        <View style={styles.card}>
          <Text style={styles.title}>Recuperar acesso</Text>
          <Text style={styles.subtitle}>Informe seu e-mail cadastrado para receber as instruções.</Text>
          <Text style={styles.label}>E-mail</Text>
          <TextInput style={styles.input} autoCapitalize="none" autoCorrect={false} keyboardType="email-address"
            placeholder="Seu e-mail cadastrado" value={email} onChangeText={setEmail} accessibilityLabel="E-mail" />
          {!!erroValidador && <Text style={styles.error}>{erroValidador}</Text>}
          <TouchableHighlight style={styles.button} disabled={loading} underlayColor="#00004C" onPress={handleSubmit} accessibilityRole="button">
            {loading ? <ActivityIndicator color="#fff" /> : <Text style={styles.buttonText}>Enviar instruções</Text>}
          </TouchableHighlight>
          <TouchableHighlight style={styles.forgot} underlayColor="#edf3fb" onPress={handleBack} accessibilityRole="button">
            <Text style={styles.forgotText}>Voltar para o login</Text>
          </TouchableHighlight>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};
const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#f4f7fb' },
  page: { flexGrow: 1, justifyContent: 'center', padding: 24, width: '100%', maxWidth: 480, alignSelf: 'center' },
  logo: { width: 190, height: 72, alignSelf: 'center', marginBottom: 10 },
  eyebrow: { color: '#5f7da1', fontSize: 10, letterSpacing: 2, fontWeight: '700', textAlign: 'center', marginBottom: 28 },
  card: { backgroundColor: '#fff', borderRadius: 24, padding: 24, borderColor: '#e1e8f2', borderWidth: 1 },
  title: { color: '#00004C', fontWeight: '700', fontSize: 24, marginBottom: 8 },
  subtitle: { color: '#63758c', fontSize: 14, lineHeight: 21, marginBottom: 28 },
  label: { color: '#00004C', fontWeight: '600', fontSize: 13, marginBottom: 8 },
  input: { minHeight: 52, width: '100%', backgroundColor: '#f7f9fc', borderRadius: 12, borderColor: '#d9e3f0', borderWidth: 1, paddingHorizontal: 14, fontSize: 16, color: '#172b4d', marginBottom: 16 },
  error: { color: '#a80101', fontSize: 13, marginBottom: 14, lineHeight: 19 },
  forgot: { alignSelf: 'flex-end', paddingVertical: 12, paddingHorizontal: 4, borderRadius: 8, marginBottom: 12 },
  forgotText: { fontSize: 13, fontWeight: '600', color: '#003c84' },
  button: { minHeight: 52, backgroundColor: '#003c84', alignItems: 'center', justifyContent: 'center', borderRadius: 12 },
  buttonText: { color: '#fff', fontSize: 16, fontWeight: '700' },
  support: { marginTop: 28, alignItems: 'center' },
  supportTitle: { color: '#00004C', fontWeight: '600', fontSize: 13, marginBottom: 6 },
  supportText: { color: '#63758c', fontSize: 12, lineHeight: 20 },
});

export default Forgot;
